export const en = ({
  titles: {
    quantity_cards: 'Cards in list: {{count}}',
    quantity_faces: 'Faces in list: {{count}}',
    tabs: {
      cards: 'Cards',
      faces: 'Faces without cards',
    },
  },
  'info block': {
    title: 'General information',
    name: 'Title',
    'owner department': 'Owner department',
    created: 'Created',
    'last changes': 'Last changes',
  },
  'edit list': {
    title: 'Edit list',
    'input label': 'List name',
    toast: {
      success: 'The list has been edited successfully',
    },
  },
  delete_modal: {
    title: 'Delete list(s)',
    subtitle: 'Choose what to do with faces in the selected list(s)',
    options: {
      with_faces: 'Delete faces',
      without_faces: 'Keep faces (detach only)',
    },
    actions: {
      delete: 'Delete list',
      cancel: 'Cancel',
    },
    toast: {
      success: 'List was successfully deleted.',
    },
  },
  filters: {
    buttons: {
      'reset button': 'Reset',
    },
    popovers: {
      face_ids: 'Face ID',
      user_data: 'User data',
      date: 'Date created',
      'external id': 'Card ID',
      fio: 'Full name',
      lists: 'Lists',
    },
  },
  sort: {
    dropdown_options: {
      date_desc: 'By creation date (newest first)',
      date_asc: 'By creation date (oldest first)',
      user_data_asc: 'By user data field (A to Z)',
      user_data_desc: 'By user data field (Z to A)',
      fio_asc: 'By full name (A to Z)',
      fio_desc: 'By full name (Z to A)',
    },
  },
  list_cards_actions: {
    create_card_label: 'Card',
  },
  list_faces_actions: {
    create_face_label: 'Face',
    export: 'Export',
    import: 'Import',
  },
  cards_bulk_actions: {
    selected_count: 'Selected: {{count}}',
    delete: 'Delete',
    add_to_list: 'Add to list',
    replace: 'Replace',
    remove_from_list: 'Remove from list',
  },
}) as Record<string, unknown>;
export const ru = ({
  titles: {
    quantity_cards: 'Карточек в списке: {{count}}',
    quantity_faces: 'Лиц в списке: {{count}}',
    tabs: {
      cards: 'Карточки',
      faces: 'Лица без карточек',
    },
  },
  'info block': {
    title: 'Общая информация',
    name: 'Название',
    'owner department': 'Подразделение владелец',
    created: 'Создан',
    'last changes': 'Последние изменения',
  },
  'edit list': {
    title: 'Редактировать список',
    'input label': 'Название',
    toast: {
      success: 'Список успешно отредактирован',
    },
  },
  delete_modal: {
    title: 'Удалить список(и)',
    subtitle: 'Выберите, что сделать с лицами в списке(ах)',
    options: {
      with_faces: 'Удалить лица',
      without_faces: 'Не удалять лица (только открепить)',
    },
    actions: {
      delete: 'Удалить список',
      cancel: 'Отмена',
    },
    toast: {
      success: 'Список успешно удален.',
    },
  },
  filters: {
    buttons: {
      'reset button': 'Очистить',
    },
    popovers: {
      face_ids: 'ID лица',
      user_data: 'Информация',
      date: 'Дата создания',
      'external id': 'ID карточки',
      fio: 'ФИО',
      lists: 'Списки',
    },
  },
  sort: {
    dropdown_options: {
      date_asc: 'По дате создания (сначала новые)',
      date_desc: 'По дате создания (сначала старые)',
      user_data_asc: 'По полю Информация (от А до Я)',
      user_data_desc: 'По полю Информация (от Я до А)',
      fio_asc: 'По ФИО (от А до Я)',
      fio_desc: 'По ФИО (от Я до А)',
    },
  },
  list_cards_actions: {
    create_card_label: 'Карточка',
  },
  list_faces_actions: {
    create_face_label: 'Лицо',
    export: 'Экспорт',
    import: 'Импорт',
  },
  cards_bulk_actions: {
    selected_count: 'Выбрано: {{count}}',
    delete: 'Удалить',
    add_to_list: 'Добавить в список',
    replace: 'Перенести',
    remove_from_list: 'Исключить из списка',
  },
}) as Record<string, unknown>;
export const ptBr = ({
  titles: {
    quantity_cards: 'Fichas na lista: {{count}}',
    quantity_faces: 'Faces na lista: {{count}}',
    tabs: {
      cards: 'Fichas',
      faces: 'Faces sem fichas',
    },
  },
  'info block': {
    title: 'Informação geral',
    name: 'Título',
    'owner department': 'Owner department',
    created: 'Criado',
    'last changes': 'Últimas alterações',
  },
  'edit list': {
    title: 'Editar lista',
    'input label': 'Nome da lista',
    toast: {
      success: 'A lista foi editada com sucesso',
    },
  },
  delete_modal: {
    title: 'Excluir lista(s)',
    subtitle: 'Escolha o que fazer com as faces nas listas selecionadas',
    options: {
      with_faces: 'Excluir faces',
      without_faces: 'Manter faces (apenas desanexar)',
    },
    actions: {
      delete: 'Excluir lista',
      cancel: 'Cancelar',
    },
    toast: {
      success: 'A lista foi excluída com sucesso.',
    },
  },
  filters: {
    buttons: {
      'reset button': 'Redefinir',
    },
    popovers: {
      face_ids: 'ID da face',
      user_data: 'Dados do usuário',
      date: 'Data de criação',
      'external id': 'ID da ficha',
      fio: 'Nome completo',
      lists: 'Listas',
    },
  },
  sort: {
    dropdown_options: {
      date_desc: 'Por data de criação (mais recente primeiro)',
      date_asc: 'Por data de criação (mais antigo primeiro)',
      user_data_asc: 'Por campo de dados do usuário (A a Z)',
      user_data_desc: 'Por campo de dados do usuário (Z a A)',
      fio_asc: 'Por nome completo (A a Z)',
      fio_desc: 'Por nome completo (Z a A)',
    },
  },
  list_cards_actions: {
    create_card_label: 'Ficha',
  },
  list_faces_actions: {
    create_face_label: 'Face',
    export: 'Exportar',
    import: 'Importar',
  },
  cards_bulk_actions: {
    selected_count: 'Selecionados: {{count}}',
    delete: 'Excluir',
    add_to_list: 'Adicionar à lista',
    replace: 'Substituir',
    remove_from_list: 'Remover da lista',
  },
}) as Record<string, unknown>;
export const esEs = ({
  titles: {
    quantity_cards: 'Tarjetas en la lista: {{count}}',
    quantity_faces: 'Rostros en la lista: {{count}}',
    tabs: {
      cards: 'Tarjetas',
      faces: 'Rostros sin tarjetas',
    },
  },
  'info block': {
    title: 'Información general',
    name: 'Título',
    'owner department': 'Departamento propietario',
    created: 'Creado',
    'last changes': 'Últimos cambios',
  },
  'edit list': {
    title: 'Editar lista',
    'input label': 'Nombre de la lista',
    toast: {
      success: 'La lista se editó correctamente',
    },
  },
  delete_modal: {
    title: 'Eliminar lista(s)',
    subtitle: 'Elija qué hacer con los rostros en la(s) lista(s) seleccionada(s)',
    options: {
      with_faces: 'Eliminar rostros',
      without_faces: 'Mantener rostros (solo desvincular)',
    },
    actions: {
      delete: 'Eliminar lista',
      cancel: 'Cancelar',
    },
    toast: {
      success: 'La lista se eliminó correctamente.',
    },
  },
  filters: {
    buttons: {
      'reset button': 'Restablecer',
    },
    popovers: {
      face_ids: 'ID de rostro',
      user_data: 'Datos de usuario',
      date: 'Fecha de creación',
      'external id': 'ID de tarjeta',
      fio: 'Nombre completo',
      lists: 'Listas',
    },
  },
  sort: {
    dropdown_options: {
      date_desc: 'Por fecha de creación (más recientes primero)',
      date_asc: 'Por fecha de creación (más antiguos primero)',
      user_data_asc: 'Por campo de datos de usuario (A a Z)',
      user_data_desc: 'Por campo de datos de usuario (Z a A)',
      fio_asc: 'Por nombre completo (A a Z)',
      fio_desc: 'Por nombre completo (Z a A)',
    },
  },
  list_cards_actions: {
    create_card_label: 'Tarjeta',
  },
  list_faces_actions: {
    create_face_label: 'Rostro',
    export: 'Exportar',
    import: 'Importar',
  },
  cards_bulk_actions: {
    selected_count: 'Seleccionados: {{count}}',
    delete: 'Eliminar',
    add_to_list: 'Agregar a la lista',
    replace: 'Reemplazar',
    remove_from_list: 'Quitar de la lista',
  },
}) as Record<string, unknown>;
